// import React from 'react';
// import styles from './UserManagement.module.css';

// const UserManagementHeader = ({ onCreateClick }) => {
//     return (
//         <div className={styles.header}>
//             <h1 className={styles.title}>User Management</h1>
//             <button className={styles.createButton} onClick={onCreateClick}>
//                 <span className={styles.buttonIcon}>+</span>
//                 Create User
//             </button>
//         </div>
//     );
// };

// export default UserManagementHeader;

import React from 'react';
import styles from './UserManagement.module.css';

const UserManagementHeader = ({ onCreateClick }) => {
    return (
        <div className={styles.header}>
            <h1 className={styles.title}>User Management</h1>
            <button className={styles.createButton} onClick={onCreateClick}>
                <span className={styles.buttonIcon}>+</span>
                Create User
            </button>
        </div>
    );
};

export default UserManagementHeader;